import { Action, createReducer, on } from '@ngrx/store';
import { Cartera } from 'src/app/models/cartera.model';
import * as carteraAction from '../actions/cartera.actions';


export interface CarteraState {
    list: any[],
    cartera?: Cartera
    carteras?: Cartera[];
}
const initialState: CarteraState = {
    list: [],
    cartera: {}
}

const _carteraReducer = createReducer(
    initialState,
    on(carteraAction.addCarteras, (state, { list }) => ({
        ...state,
        list: [...list]
    })),
    on(carteraAction.listCarteras, (state) => ({
        ...state,
    })),
    on(carteraAction.addCartera, (state, { cartera }) => ({
        ...state,
        list: [...state.list, cartera]
    })),
    on(carteraAction.selectCartera, (state, { id }) => ({
        ...state,
        cartera: state.list.find(el => el.car_id == id)
    })),
    on(carteraAction.deleteCartera, (state, { id }) => ({
        ...state,
        list: state.list.filter(x => x.car_id != id)
    })),
    on(carteraAction.updateListCarteras, (state, { id, cartera }) => ({
        ...state,
        list: state.list.map((el) => {
            
            if (el.car_id == id) {
                return el = {
                    ...cartera
                }

            } else {
                return el;
            }
        })
    }))
)


export function carteraReducer(state: CarteraState, action: Action) {
    return _carteraReducer(state, action);
}